import { template as template_d2a5194ad6004f21b9359b52fe9e4cb4 } from "@ember/template-compiler";
import { LinkTo } from '@ember/routing';
import Component from '@glimmer/component';
import styles from './join-waitlist.module.scss';
import t from 'ember-intl/helpers/t';
export default class RequestDateJoinWaitlist extends Component {
    styles = styles;
    static{
        template_d2a5194ad6004f21b9359b52fe9e4cb4(`
    <div class={{styles.component}}>
      <div class="inner" data-test-join-waitlist-cta>
        <div class="copy">
          <p class="title">{{t "availability.joinWaitlist.title"}}</p>
          <p class="subtitle">{{t "availability.joinWaitlist.subtitle"}}</p>
        </div>

        <LinkTo @route="site.waitlist-intake" class="button primary" data-test-join-waitlist-button>
          {{t "availability.joinWaitlist.cta"}}
        </LinkTo>
      </div>
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
